module.exports = __webpack_public_path__ + "img/placeholder-de.aa614ee1.jpg";